class USPSlider {
  constructor(sliderEl) {
    this.slider = sliderEl;
    this.track = sliderEl.querySelector('.usp-slider__track');
    this.slides = Array.from(sliderEl.querySelectorAll('.usp-slide'));
    this.prevBtn = sliderEl.closest('.usp-container').querySelector('.usp-nav__btn--prev');
    this.nextBtn = sliderEl.closest('.usp-container').querySelector('.usp-nav__btn--next');
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;

    if (!this.track || this.slides.length === 0) return;

    this.init();
  }

  init() {
    this.updateSlidesPerView();
    this.updateButtons();
    this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn.addEventListener('click', () => this.next());

    this.track.addEventListener('touchstart', this.touchStart.bind(this), { passive: true });
    this.track.addEventListener('touchmove', this.touchMove.bind(this), { passive: true });
    this.track.addEventListener('touchend', this.touchEnd.bind(this));

    this.track.addEventListener('mousedown', this.dragStart.bind(this));
    this.track.addEventListener('mousemove', this.dragMove.bind(this));
    this.track.addEventListener('mouseup', this.dragEnd.bind(this));
    this.track.addEventListener('mouseleave', this.dragEnd.bind(this));

    window.addEventListener('resize', () => {
      this.updateSlidesPerView();
      this.updateButtons();
      this.setPositionByIndex(this.currentIndex);
    });
  }

  getSlidesPerView() {
    const style = getComputedStyle(this.slider);
    const width = this.slider.offsetWidth;

    if (width >= 990) {
      return parseInt(style.getPropertyValue('--usp-desktop-slides')) || 3;
    } else if (width >= 768) {
      return parseInt(style.getPropertyValue('--usp-tablet-slides')) || 2;
    } else {
      return parseInt(style.getPropertyValue('--usp-mobile-slides')) || 1;
    }
  }

  updateSlidesPerView() {
    this.slidesPerView = this.getSlidesPerView();
    this.maxIndex = Math.max(0, this.slides.length - this.slidesPerView);
    if (this.currentIndex > this.maxIndex) {
      this.currentIndex = this.maxIndex;
    }
  }

  getSlideWidth() {
    const gap = parseFloat(getComputedStyle(this.slider).getPropertyValue('--usp-slide-gap')) || 24;
    const containerWidth = this.slider.offsetWidth;
    return (containerWidth - (this.slidesPerView - 1) * gap) / this.slidesPerView + gap;
  }

  setPositionByIndex(index) {
    const slideWidth = this.getSlideWidth();
    this.currentTranslate = -index * slideWidth;
    this.prevTranslate = this.currentTranslate;
    this.track.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    this.track.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  updateButtons() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex <= 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }
  }

  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.setPositionByIndex(this.currentIndex);
      this.updateButtons();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.setPositionByIndex(this.currentIndex);
      this.updateButtons();
    }
  }

  getPositionX() {
    return this.currentTranslate;
  }

  touchStart(e) {
    this.isDragging = true;
    this.startX = e.touches[0].clientX;
    this.track.style.transition = 'none';
  }

  touchMove(e) {
    if (!this.isDragging) return;
    const currentX = e.touches[0].clientX;
    const diff = currentX - this.startX;
    this.currentTranslate = this.prevTranslate + diff;
    this.track.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  touchEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    const movedBy = this.currentTranslate - this.prevTranslate;
    const slideWidth = this.getSlideWidth();
    const threshold = slideWidth * 0.2;

    if (movedBy < -threshold && this.currentIndex < this.maxIndex) {
      this.currentIndex++;
    } else if (movedBy > threshold && this.currentIndex > 0) {
      this.currentIndex--;
    }

    this.setPositionByIndex(this.currentIndex);
    this.updateButtons();
  }

  dragStart(e) {
    e.preventDefault();
    this.isDragging = true;
    this.startX = e.clientX;
    this.track.style.transition = 'none';
    this.track.style.cursor = 'grabbing';
  }

  dragMove(e) {
    if (!this.isDragging) return;
    const currentX = e.clientX;
    const diff = currentX - this.startX;
    this.currentTranslate = this.prevTranslate + diff;
    this.track.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  dragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.style.cursor = 'grab';
    const movedBy = this.currentTranslate - this.prevTranslate;
    const slideWidth = this.getSlideWidth();
    const threshold = slideWidth * 0.2;

    if (movedBy < -threshold && this.currentIndex < this.maxIndex) {
      this.currentIndex++;
    } else if (movedBy > threshold && this.currentIndex > 0) {
      this.currentIndex--;
    }

    this.setPositionByIndex(this.currentIndex);
    this.updateButtons();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-usp-slider]').forEach((slider) => {
    new USPSlider(slider);
  });
});
